module.exports = "<!-- PAGE CONTENT -->\n<div>\n    <!-- LOADING... -->\n    <div class=\"app-loading\" *ngIf=\"isLoading\">\n        Loading Atomic Mole...\n    </div>\n    <router-outlet></router-outlet>\n</div>\n<!-- END PAGE CONTENT -->\n\n\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main